import React, { useState, useEffect } from "react";
import i18n from "i18n-js";
import Localization from '../../../shared/Localization';
import Toast from '../../../shared/Notifications/Toast';
import FrequentlyAskedQuestionsApiHelpers from './FrequentlyAskedQuestionsApiHelpers';
import './FrequentlyAskedQuestions.scss';
import {IFaqsServiceObj} from "../../../shared/apiServices/IApiInterfaces";

const FrequentlyAskedQuestions = () => {
  const [local, setLocal] = useState<typeof i18n | null>(null);
  const [faqs, setFaqs] = useState([] as IFaqsServiceObj[]);
  const [loaded, setLoaded] = useState(Boolean);

  useEffect(() => {
    setLoaded(false);
    const setNewLocal = async () => {
      const newLocal = await Localization("en");
      setLocal(newLocal);
    };
    setInitialStates();
    setNewLocal();
  }, []);

  async function setInitialStates() {
    try {
      const initialFaqs: IFaqsServiceObj[] = await FrequentlyAskedQuestionsApiHelpers.getAllFaqs()
      setFaqs(initialFaqs);
      setLoaded(true);
    }
    catch (error) {
      Toast.show('Error Getting Frequently Asked Questions');
      console.error(error);
    }

  }

  //reference -> https://github.com/ALapina/FAQ-Accordion-Card-React
  const AccordionItem = ({
    answerText,
    ariaExpanded,
    questionText,
    item,
    index,
    onClick
  }: {
    answerText: any,
    ariaExpanded: any,
    questionText: any,
    item: any,
    index: any,
    onClick: any
  }

  ) => (
    <div className="faq-question" data-testid={item.id} key={item.question}>
      <dt>
        <button
          aria-expanded={ariaExpanded}
          aria-controls={`faq${index + 1}-desc`}
          className={`faq-question-button ${questionText}`}
          onClick={onClick}
        >
          {item.question}
        </button>
      </dt>
      <dd>
        <p
          id={`faq${index + 1}-desc`}
          data-testid={`faq${index + 1}-desc`}
          data-qa="faq-desc"
          className={`faq-desc ${answerText}`}
        >
          {<b>Answer: </b>}{item.answer}
        </p>
      </dd>
    </div>
  );

  const Accordion = ({ faqs }: { faqs: IFaqsServiceObj[] }) => {
    const [activeIndex, setActiveIndex] = useState(Infinity);

    const renderedQuestionsAnswers = faqs.map((faq, index) => {
      const answerText = index === activeIndex ? "answer-text" : "";
      const questionText = index === activeIndex ? "question-text" : "";
      const ariaExpanded = index === activeIndex ? "true" : "false";
      return (
        <AccordionItem
          answerText={answerText}
          questionText={questionText}
          ariaExpanded={ariaExpanded}
          item={faq}
          key={faq.id}
          index={index}
          onClick={() => {
            activeIndex == index ? setActiveIndex(Infinity) : setActiveIndex(index);
          }}
        />
      );
    });

    return (
      <div className="faq">
        <h1 className="faq-title">Frequently Asked Questions</h1>
        <dl className="faq-list">{renderedQuestionsAnswers}</dl>
      </div>
    );
  };

  return loaded ? <Accordion faqs={faqs} /> : <div>Loading...</div>
    
  
};



export default FrequentlyAskedQuestions;